<script setup lang="ts">
// Extract the first part of the URL path
const showQuizModal = ref(false);
const toggleQuizModal = () => {
  showQuizModal.value = !showQuizModal.value;
};

const closeQuizModal = () => {
  showQuizModal.value = false;
};
</script>

<template>
  <Teleport to="body">
    <Transition name="pop" appear>
      <div v-if="showQuizModal" v-cloak class="modal quiz-modal">
        <div class="close-modal" @click="closeQuizModal"></div>
        <AppFitnessQuiz />
      </div>
    </Transition>
    <Transition name="fade" appear>
      <div
        v-if="showQuizModal"
        v-cloak
        class="backdrop"
        @click="closeQuizModal"
      ></div>
    </Transition>
  </Teleport>
  <section id="quizGrading">
    <section class="content">
      <div class="btn-wrap">
        <div class="quiz-btn">
          <h2>Are You Trek Ready?</h2>
          <p>Find out with our quick fitness quiz ...</p>

          <div class="btn from-left" @click.prevent="toggleQuizModal">
            FITNESS QUIZ
          </div>
        </div>
        <div class="image">
          <NuxtPicture
            format="webp"
            loading="lazy"
            src="/images/hikers.jpg"
            width="400"
            height="250"
            alt="Hikers"
            sizes="sm:200px md:300px lg:400px"
          />
        </div>
        <div class="grading-btn">
          <h2>See How We Grade Treks</h2>
          <p>Discover our trek grading system ...</p>
          <NuxtLink to="/essential-info/trek-grading" class="btn from-left">
            Trek Grading
          </NuxtLink>
        </div>
      </div>
    </section>
  </section>
</template>
